export const PRICING_URLS: Record<string, string> = {
  sl: 'https://autobrief.io/cenik/',
  hr: 'https://autobrief.io/hr/cjenik/',
  en: 'https://autobrief.io/en/prices/',
  de: 'https://autobrief.io/en/prices/',
};

export function getPricingUrl(locale: string): string {
  return PRICING_URLS[locale] ?? PRICING_URLS['en'];
}

/**
 * CarPeak marketing/pricing URLs keyed by locale.
 *   - sl → Cenik
 *   - hr → Cjenik
 *   - everything else → English Pricing
 *
 * Lives next to `PRICING_URLS` so marketing can update both in one
 * place instead of grepping the codebase. If you're tempted to inline
 * a URL anywhere in the app, point at this constant instead.
 */
export const CARPEAK_PRICING_URLS: Record<string, string> = {
  sl: 'https://carpeak.io/sl/cenik',
  hr: 'https://carpeak.io/hr/cjenik',
  en: 'https://carpeak.io/pricing',
  de: 'https://carpeak.io/pricing',
};

export function getCarPeakPricingUrl(locale: string): string {
  return CARPEAK_PRICING_URLS[locale] ?? CARPEAK_PRICING_URLS['en'];
}
